"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailAddressDomainPulldownInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var models_1 = require("../../../models");
var ErrorMessage_1 = require("../ErrorMessage");
var FieldHeading_1 = require("../FieldHeading");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var Select_1 = require("../Select");
var MailAddressSeparatedInput_1 = require("./MailAddressSeparatedInput");
var MailAddressDomainPulldownInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, domains = _a.domains, onLocalChange = _a.onLocalChange, onDomainChange = _a.onDomainChange, onLocalBlur = _a.onLocalBlur, onDomainBlur = _a.onDomainBlur, local = _a.local, domain = _a.domain, errorMessages = _a.errorMessages, disabled = _a.disabled, design = _a.design, className = _a.className, displayError = _a.displayError;
    var inputFont = design.colors.inputFont;
    var handleLocalChange = function (e) {
        onLocalChange(e.target.value);
    };
    var handleDomainChange = function (e) {
        onDomainChange(e.target.value);
    };
    var handleLocalBlur = function (e) {
        if (onLocalBlur) {
            onLocalBlur(e.target.value);
        }
    };
    var handleDomainBlur = function (e) {
        if (onDomainBlur) {
            onDomainBlur(e.target.value);
        }
    };
    var LocalInput = (jsx_runtime_1.jsx(Input_1.Input, { error: displayError, "data-cy-property-item": "local", value: local, type: "text", placeholder: placeholder, onChange: handleLocalChange, onBlur: handleLocalBlur, disabled: disabled, name: propertyId + "-local", inputMode: "email", autoCorrect: "off", autoCapitalize: "off", id: propertyId, "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) }, void 0));
    var DomainInput = (jsx_runtime_1.jsx(Select_1.Select, __assign({ error: displayError, "data-cy-property-item": "domain", onChange: handleDomainChange, onBlur: handleDomainBlur, value: domain, disabled: disabled, name: propertyId + "-domain", "aria-labelledby": FieldHeading_1.getLabelId(propertyId), "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) }, { children: domains &&
            domains.map(function (domain) { return (jsx_runtime_1.jsx("option", __assign({ value: domain }, { children: domain }), domain)); }) }), void 0));
    return (jsx_runtime_1.jsx(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.mailAddress, inputFormatType: models_1.MAIL_ADDRESS_PROPERTY_INPUT_TYPE.domainPulldown, errorMessages: errorMessages, className: className, displayError: displayError }, { children: jsx_runtime_1.jsx(MailAddressSeparatedInput_1.MailAddressSeparatedInput, { color: inputFont, localInput: LocalInput, domainInput: DomainInput }, void 0) }), void 0));
};
exports.MailAddressDomainPulldownInput = MailAddressDomainPulldownInput;
